<template>
  <div style="background: rgb(246, 248, 251);height: 100vh;width: 100%;">
    <el-container>
      <el-main class="mainContent" style="height: 100vh; background: #fff;">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 15px; font-size: 14px;">
            分析
            <el-input
              size="small"
              style="width: 220px; padding: 0 10px; border-radius: 4px;"
              placeholder="输入员工姓名"
              v-model="searchKeyword"
            ></el-input>
            在最近<el-input-number
              size="small"
              style="width: 120px; padding: 0 10px; border-radius: 4px;"
              placeholder="天数"
              v-model="limit"
              :value="6"
            ></el-input-number>
            天的工作动态
          </div>
          <el-button type="primary" @click="analyzeDynamics" :loading="loading">开始分析</el-button>
        </div>
        <div style="border-bottom: 2px solid rgb(246, 248, 253);width: 100%;margin: 10px 0;"></div>
        <div v-if="analysisResult">
          <h3>分析结果</h3>
          <div class="stream-result">
            <div v-for="(line, index) in analysisResult.split('\n')" :key="index">{{ line }}</div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {getDynamicsAnalysis} from '@/api/doOneGood';

export default {
  name: "AiDynamicAnalysis",
  data() {
    return {
      searchKeyword: "",
      limit: 6,
      content: "",
      analysisResult: '',
      loading: false,
      selectLoading: false
    };
  },
  methods: {
    async analyzeDynamics() {
      if (!this.searchKeyword) {
        this.$message.error('请输入员工姓名');
        return;
      }

      this.loading = true;
      this.analysisResult = '正在分析，请稍等。。。';
      try {
        const params = {
          keywords: this.searchKeyword,
          limit: this.limit?this.limit:7,
          content:""
        };

        const { code, data } = await getDynamicsAnalysis(params);
        if (code == 200) {
          this.analysisResult = String(data);
        } else {
          this.$message.error('分析失败，请稍后重试');
        }
        this.loading = false;
      } catch (error) {
        console.error('分析失败', error);
        this.$message.error('分析失败，请稍后重试');
        this.loading = false;
      }
    },

  }
};
</script>

<style lang="scss" scoped>
.mainContent {
  padding: 20px;
}
.stream-result {
  white-space: pre-wrap;
  border: 1px solid #eee;
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
  min-height: 100px;
  background-color: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/OneGoodModule/AiDynamicAnalysis.vue